var _defs, _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeometry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 50,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "c64c3c33fb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 75.132812 88.054688 L 300 88.054688 L 300 286.804688 L 75.132812 286.804688 Z M 75.132812 88.054688 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c835190e48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 75.132812 88.054688 L 258 88.054688 L 258 286.804688 L 75.132812 286.804688 Z M 75.132812 88.054688 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fe3114f5c1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 130 88.054688 L 300 88.054688 L 300 260 L 130 260 Z M 130 88.054688 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "17fca1db04"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 91 138 L 300 138 L 300 286.804688 L 91 286.804688 Z M 91 138 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c64c3c33fb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ba1f33",
    d: "M 201.015625 88.054688 L 170.960938 88.054688 L 75.214844 262.097656 L 91.308594 286.921875 L 280.140625 286.921875 L 299.785156 259.546875 Z M 142.789062 237.742188 L 186.496094 162.632812 L 230.078125 237.742188 Z M 142.789062 237.742188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c835190e48)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dc2e45",
    d: "M 75.214844 262.097656 L 170.960938 88.054688 L 257.28125 237.742188 L 230.300781 238.132812 L 172.730469 138.90625 L 91.308594 286.921875 Z M 75.214844 262.097656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fe3114f5c1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e15164",
    d: "M 299.785156 259.546875 L 130.105469 259.546875 L 142.789062 237.742188 L 257.28125 237.742188 L 170.960938 88.054688 L 201.003906 88.054688 Z M 299.785156 259.546875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#17fca1db04)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ba1f33",
    d: "M 186.507812 162.644531 L 130.105469 259.558594 L 299.785156 259.558594 L 280.140625 286.933594 L 91.308594 286.933594 L 172.730469 138.90625 Z M 186.507812 162.644531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeometry);
export default __webpack_public_path__ + "static/media/geometry.02a42bb74a746447d38682c7bc2a463f.svg";
export { ForwardRef as ReactComponent };